import { PageNextOutlineIcon } from './PageNextOutlineIcon';

/**
 * author: Michael Richins
 * id 9213C60D-0232-4ECB-91C6-8D2BF812FE6A
 * name page-next-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-next-outline.svg
 * tags
 */
export const ReadMoreOutlineIcon = PageNextOutlineIcon;
export default ReadMoreOutlineIcon